import { render, staticRenderFns } from "./LaudoForm.vue?vue&type=template&id=57043499&"
import script from "./LaudoForm.js?vue&type=script&lang=js&"
export * from "./LaudoForm.js?vue&type=script&lang=js&"
import style0 from "./LaudoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCircularProgress,QIcon,QForm,QInput,QBtn,QSelect,QItem,QItemSection,QTabPanel});
